module.exports = __webpack_public_path__ + "static/media/online_interactive_picture_book.6c8913cb.pdf";